export default {"src":"/_next/static/media/mirror.8d191e11.svg","height":760,"width":1094};